import { get } from 'lodash';
import { conditionsMsg, proceduresMsg } from '../validationMessages';

function validateStance(caseConf) {
  const errors = [];
  const warnings = [];

  const nasalSwabTreatment =
    caseConf._treatments &&
    caseConf._treatments.find((x) => x.id === 'NASAL_SWAB');
  const isNasalSwab = nasalSwabTreatment && nasalSwabTreatment.options.enabled;

  const vagalManeuverTreatment =
    caseConf._treatments &&
    caseConf._treatments.find((x) => x.id === 'VAGAL_MANEUVER');
  const isVagalManeuver = vagalManeuverTreatment && vagalManeuverTreatment.options.enabled;

  const startLocationKey = caseConf._startLocation.key;
  const endLocationKey = caseConf._endLocation ? caseConf._endLocation.key : null;

  if (startLocationKey === 'HELICOPTER') {
    const positionState = caseConf._initialStates.find(state => state.id === 'position');
    const startingPosition = get(positionState, 'options.value');
    if (startingPosition === 'SIT') {
      errors.push(
        conditionsMsg('Patient cannot be in the seated forward position when the starting scene is Helicopter', 'position')
      );
    }
  }

  const usesHelicopter = startLocationKey === 'HELICOPTER' || endLocationKey === 'HELICOPTER';
  const onlyHelicopter = startLocationKey === 'HELICOPTER' && (!endLocationKey || endLocationKey === 'HELICOPTER');

  if (usesHelicopter && isNasalSwab) {
    warnings.push(
      proceduresMsg(
        'Nasal swab is unavailable when patient is in the helicopter',
        'NASAL_SWAB',
        { defaultVisibility: onlyHelicopter }
      )
    );
  }

  if (usesHelicopter && isVagalManeuver) {
    warnings.push(
      proceduresMsg(
        'Vagal maneuver is unavailable when patient is in the helicopter',
        'VAGAL_MANEUVER',
        { defaultVisibility: onlyHelicopter }
      )
    );
  }

  return {
    errors,
    warnings,
  };
}

export default validateStance;
